module.exports = __webpack_public_path__ + "img/stepOne.5f4bce4b.jpg";